export default {
  SET_employees(state, payload) {
    state.employees = payload
  },
  SET_birthdays(state, payload) {
    state.birthdays = payload
  },
  SET_contactMessagesWebSite(state, payload) {
    state.contactMessagesWebSite = payload
  },
  SET_paychecks(state, paylaod) {
    state.paychecks = paylaod
  },
  SET_scales(state, payload) {
    state.scales = payload
  },
  SET_income_taxes(state, payload) {
    state.income_taxes = payload
  },
}
